import React, { Component } from 'react'
import { connect } from 'react-redux';
import Service from '../../services';
import Authentication from '../../session';
import withRouter from '../../lib/withRouter';
import { Button } from 'primereact/button';
import ClassetInputText from '../../../classetComponents/classetInputText';
import ClassetDropdown from '../../../classetComponents/classetDropDown';
import { getFormFields, isFormValid, onDropDownChange, onEmailChange, onTextChange } from '../../../utile/formHelper';
import { baseUrlAdmin } from '../../../store/apiConstants';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import ClassetTextArea from '../../../classetComponents/classetTextArea';
import ClassetCalendar from '../../../classetComponents/classetCalender';
import PopulateDynamicForm from '../../../classetComponents/classetPopulateDynamicForm';
import { getBoardsData, getBranchesLatest } from '../../../store/actions';
import { userAssignedBoards } from '../../../store/selectors/userAssignedBoards';
import { convertUtc, trimObj } from '../../../utile';
import LoadingComponent from '../../loadingComponent';
import FileUpload from '../../fileUpload';
import { FileAttachmentIcon } from '../../svgIcons';
import gradesEnum from '../../../constants/grades.json';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ProgressSpinner } from 'primereact/progressspinner';
// import { Column } from "primereact/column";
import countryPhoneCodes from '../../../constants/countryPhoneCodes.json';
import countries from '../../../constants/countries.json';
import motherTongue from '../../../constants/motherTongue.json';
import castes from '../../../constants/castes.json';
import religions from '../../../constants/religions.json';
import states from '../../../constants/states.json';
import cityOrDist from '../../../constants/cityOrDist.json';
import districts from '../../../constants/districts.json';
import area from '../../../constants/area.json';
import enquiry from '../../admissionNewManagement/admissionProcess/enquiry';


const createEnquiryFields = require('./enquiryAdd.json');

const formFields = createEnquiryFields
class EnquiryAdd extends Component {

    constructor(props) {
        super(props);
        // const userAcademicYear = localStorage.getItem('userAcademicYear');
        const userAcademicYear = this.props.selectedOption || localStorage.getItem('userAcademicYear');

        // Transform the JSON data to match dropdown format
        const transformedCountryPhoneCodes = countryPhoneCodes.map(country => ({
            label: `${country.country} (+${country.code})`,
            value: country.code,
            country: country.country,
            iso: country.iso
        }));

        const transformedMotherTongue = motherTongue.map(lang => ({
            label: lang.label,
            value: lang.value
        }));

        const transformedCastes = castes.map(caste => ({
            label: caste.label,
            value: caste.value
        }));

        const transformedReligions = religions.map(religion => ({
            label: religion.label,
            value: religion.value
        }));

        const transformedCountries = countries.map(country => ({
            name: country.name,
            code: country.code
        }));

        const transformedStates = states.map(state => ({
            label: state.label,
            value: state.value
        }));

        const transformedCityOrDist = cityOrDist.map(city => ({
            label: city.label,
            value: city.value
        }));

        const transformedArea = area.map(area => ({
            label: area.label,
            value: area.value
        }));

        // Transform grades from grades.json for classStudyingDrp
        const transformedGrades = Object.entries(gradesEnum).map(([label, value]) => ({
            label: label,
            value: value
        }));

        this.formFields = getFormFields(createEnquiryFields);
        // Initialize parents and siblings from selectedEnquiry if editing
        const isEditing = this.props?.selectedEnquiry?._id;
        const initialParents = isEditing && this.props.selectedEnquiry?.enquiry?.parents?.length > 0
            ? this.props.selectedEnquiry?.enquiry?.parents
            : [
                {
                    parentType: '',
                    parentName: '',
                    qualification: '',
                    profession: '',
                    countryCode: '',
                    parentContact: '',
                    parentEmailId: '',
                }
            ];

        const initialSiblings = isEditing && this.props.selectedEnquiry?.enquiry?.siblings?.length > 0
            ? this.props.selectedEnquiry?.enquiry?.siblings
            : [
                { name: "", gender: "", classStudying: "", schoolStudying: "" }
            ];
        this.state = {
            showCountriesSubmenu: false,
            countrySearchTerm: '',
            isLoading: false,
            feePlans: [],
            academicCategory: [],
            boards: [],
            // list of common country phone codes
            countryPhoneCodes: transformedCountryPhoneCodes,
            motherTongue: transformedMotherTongue,
            castes: transformedCastes,
            religions: transformedReligions,
            countries: transformedCountries,
            state: transformedStates,
            cityOrDist: transformedCityOrDist,
            area: transformedArea,


            knowAboutUs: [
                { label: 'Online', value: "Online" },
                { label: 'Self', value: "Self" },
                { label: 'family', value: "family" },
                { label: 'Advertisement', value: "Advertisement" }
            ],
            // Add this to the state in constructor
            govtIdTypes: [
                { label: "Aadhaar Card", value: "aadhaar" },
                // { label: "PAN Card", value: "pan" },
                { label: "Passport", value: "passport" },
                // { label: "Voter ID", value: "voter_id" },
                // { label: "Driving License", value: "driving_license" },
                // { label: "Ration Card", value: "ration_card" },
                // { label: "Birth Certificate", value: "birth_certificate" },
                { label: "Other", value: "other" }
            ],

            // all countries
            gender: [
                { label: "Male", value: "male" },
                { label: "Female", value: "female" },
                { label: "Other", value: "other" },
            ],
            parentTypes: [
                { label: 'Father', value: "Father" },
                { label: 'Mother', value: "Mother" },
                { label: 'Guardian', value: "Guardian" }
            ],
            previousBoards: [
                { label: "Central Board of Secondary Education (CBSE)", value: "CBSE" },
                { label: "Indian Certificate of Secondary Education (ICSE)", value: "ICSE" },
                { label: "International Baccalaureate (IB)", value: "IB" },
                { label: "Cambridge Assessment International Education (IGCSE)", value: "IGCSE" },
                { label: "State Board", value: "State" },
                { label: "National Institute of Open Schooling (NIOS)", value: "NIOS" },
                { label: "Council for the Indian School Certificate Examinations (CISCE)", value: "CISCE" },
                { label: "Other", value: "Other" },
            ],




            pickupFee: 'average',
            preferences: false,
            refundable: false,
            refundErr: '',
            enquiry: this.props?.selectedEnquiry?._id ? this.props?.selectedEnquiry?.enquiry : {
                ...this.formFields.data,
                // Set default admission test based on settings (will be updated in componentDidMount)
                admissionTest: false,
                // academicSession: userAcademicYear || ''
            },
            // enquiry: {
            //     ...(this.props?.selectedEnquiry?._id ? this.props?.selectedEnquiry?.enquiry : this.formFields.data),
            //     ...this.formFields.data,
            //     academicSession: userAcademicYear || '' 
            // },
            formValidations: this.formFields.formValidations,
            addDifferentialFeeAllow: false,
            isEdit: false,
            // Update parents and siblings initialization
            parents: initialParents,
            parentValidations: [{}], // Validation state for each parent
            siblings: initialSiblings,
            dob: null, selectedClassesList: [],
            // siblings: [
            //     { name: "", gender: "", classStudying: "", schoolStudying: "" }
            // ],
            genderData: [
                { label: "Male", value: "male" },
                { label: "Female", value: "female" }
            ],

            classStudyingDrp: transformedGrades,
            // classStudyingDrp: [
            //     { label: "Nursery", value: "nursery" },
            //     { label: "LKG", value: "lkg" }, { label: "UKG", value: "ukg" },
            //     { label: "I", value: "i" }, { label: "II", value: "ii" }, { label: "III", value: "iii" }, { label: "IV", value: "iv" },
            //     { label: "V", value: "v" }, { label: "VI", value: "vi" }, { label: "VII", value: "vii" }, { label: "VIII", value: "viii" },
            //     { label: "IX", value: "ix" }, { label: "X", value: "x" }, { label: "XI", value: "xi" }, { label: "XII", value: "xii" }
            // ],
            hideUpdateButton: false,

            states: [], // Added state for countries
            cities: [], // Added state for cities
            pincodes: [], // Added state for pincodes

            // Age Criteria DOB Modal states
            showAgeCriteriaDobModal: false,
            tempDob: null, // Temporary DOB for modal
        }
        this.service = new Service();
    }


    async componentDidMount() {
        // await this.getCountryPhoneCodes(); // Fetch country phone codes

        await this.getAdmissionSettingsInfo()
        await this.getCouncellorsInfo()
        await this.getAdmissionTypeDropdown()
        await this.getAcademicSessions()

        const storedFields = localStorage.getItem('fields');
        if (storedFields) {
            const parsedFields = JSON.parse(storedFields);
            this.setState(prevState => ({
                enquiry: {
                    ...prevState.enquiry,
                    customFields: parsedFields
                }
            }));
        }

        // Set default admission test value based on admission settings
        if (this.state.admissionSettingsInfo?.examTest && !this.props?.selectedEnquiry?._id) {
            this.setState(prevState => ({
                enquiry: {
                    ...prevState.enquiry,
                    admissionTest: true // Enable by default if exam is enabled in settings
                }
            }));
        }

        // Check if age criteria is required and show modal for new enquiry (not editing)
        if (this.state.admissionSettingsInfo?.ageCriteria && !this.props?.selectedEnquiry?._id && !this.state.dob) {
            this.setState({ showAgeCriteriaDobModal: true });
        }

        if (this.props?.selectedEnquiry?._id && this.props?.selectedEnquiry?.branch) {
            // Load districts for selected state if editing
            const selectedState = this.props?.selectedEnquiry?.enquiry?.state;
            let districtsList = [];
            if (selectedState && districts[selectedState]) {
                districtsList = districts[selectedState].map(district => ({
                    label: district,
                    value: district
                }));
            }

            this.setState({
                isEdit: true,
                dob: new Date(this.props?.selectedEnquiry?.dob),
                cityOrDist: districtsList.length > 0 ? districtsList : this.state.cityOrDist,
                // Ensure parents and siblings are set if not already done in constructor
                parents: this.props.selectedEnquiry.enquiry?.parents?.length > 0
                    ? this.props.selectedEnquiry.enquiry?.parents
                    : this.state.parents,
                siblings: this.props.selectedEnquiry.enquiry?.siblings?.length > 0
                    ? this.props.selectedEnquiry.enquiry?.siblings
                    : this.state.siblings
            })
            this.onChangeBranch(this.props?.selectedEnquiry?.branch)
            this.onChangeBoard(this.props?.selectedEnquiry?.board)
        }

        // Listen for academic year changes from localStorage and custom events
        window.addEventListener('storage', this.handleStorageChange);
        window.addEventListener('academicYearChanged', this.handleAcademicYearChange);

        // Sync with AppTopbar academic year options if available
        if (this.props.academicYearOptions?.length && !this.state.academicSession?.length) {
            this.setState({ academicSession: this.props.academicYearOptions });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('storage', this.handleStorageChange);
        window.removeEventListener('academicYearChanged', this.handleAcademicYearChange);
    }

    handleAcademicYearChange = async (event) => {
        const { academicYearId } = event.detail;

        // Update local state
        this.setState(prevState => ({
            enquiry: {
                ...prevState.enquiry,
                academicSession: academicYearId
            }
        }));

        // If the event came from AppTopbar, also refresh local academic sessions
        if (!this.props.academicYearOptions?.length) {
            await this.refreshAcademicSessions();
        }

        // Refresh dependent data
        await this.refreshAcademicYearDependentData();
    };

    // Update componentDidUpdate to sync when props change
    componentDidUpdate(prevProps) {
        // Sync academic year options when they come from props
        if (this.props.academicYearOptions?.length &&
            this.props.academicYearOptions !== prevProps.academicYearOptions) {
            this.setState({ academicSession: this.props.academicYearOptions });
        }
    }

    handleStorageChange = (e) => {
        if (e.key === 'userAcademicYear') {
            this.setState(prevState => ({
                enquiry: {
                    ...prevState.enquiry,
                    academicSession: e.newValue
                }
            }));
        }
    };

    getCouncellorsInfo = async () => {
        this.setState({
            isLoading: true
        });
        let academicYear = localStorage.getItem('userAcademicYear')
        let url = `${baseUrlAdmin}/admin/getFilteredUseres`;
        try {
            let payload = {
                academicYear,
                type: "counsellor"
            }
            const res = await this.service.post(url, payload, true);
            if (res?.res?.status && res.status) {
                this.setState({ counsellorInfo: res?.res?.data, isLoading: false });
            } else {
                this.setState({ isLoading: false });
                this.toast?.show({ severity: 'error', summary: 'Error', detail: 'Some error occured', life: 3000 });
            }
        } catch (e) {
            this.setState({ isLoading: false });
            this.toast?.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
        }
    }

    getAdmissionSettingsInfo = async () => {
        this.setState({
            isLoading: true
        });
        let academicYear = localStorage.getItem('userAcademicYear')
        let url = `${baseUrlAdmin}/admissions/process?academicYear=${academicYear}`;
        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {
                this.setState({ admissionSettingsInfo: res?.res?.data, isLoading: false });
            } else {
                this.setState({ isLoading: false });
                this.toast?.show({ severity: 'error', summary: 'Error', detail: 'Some error occured', life: 3000 });
            }
        } catch (e) {
            this.setState({ isLoading: false });
            this.toast?.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
        }
    }

    handleAgeCriteriaDobAccept = () => {
        const { tempDob } = this.state;

        if (!tempDob) {
            this.toast?.show({
                severity: 'error',
                summary: 'Required',
                detail: 'Please select Date of Birth',
                life: 3000
            });
            return;
        }

        // Set the DOB in both state.dob and enquiry.dob
        this.setState({
            dob: tempDob,
            enquiry: {
                ...this.state.enquiry,
                dob: tempDob
            },
            showAgeCriteriaDobModal: false,
            tempDob: null
        }, () => {
            // Call onSetClasses to filter classes based on age criteria
            this.onSetClasses();
        });
    }




    getAdmissionTypeDropdown = async () => {
        this.setState({
            isLoading: true
        });
        const academicYear = localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/admission-types/active?academicYear=${academicYear}`
        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {
                const result = res?.res?.data?.map(admision => ({
                    label: admision.categoryName,
                    value: admision._id
                }));

                this.setState({ academicCategory: result, isLoading: false });
            } else {
                this.setState({ isLoading: false });
                this.toast?.show({ severity: 'error', summary: 'Error', detail: 'Some error occured', life: 3000 });
            }
        } catch (e) {
            this.setState({ isLoading: false });
            this.toast?.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
        }

    };

    getAcademicSessions = async () => {
        this.setState({
            isLoading: true
        });
        let url = `${baseUrlAdmin}/academic-years/`;
        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {
                const result = res?.res?.data?.map(admision => ({
                    label: admision.academicCode,
                    value: admision._id,
                    academicCode: admision.academicCode,
                    _id: admision._id
                }));

                const userAcademicYear = localStorage.getItem('userAcademicYear');

                this.setState(prevState => ({
                    academicSession: result,
                    isLoading: false,
                    enquiry: {
                        ...prevState.enquiry,
                        academicSession: userAcademicYear || (result[0]?.value || '')
                    }
                }));
            } else {
                this.setState({ isLoading: false });
                this.toast?.show({ severity: 'error', summary: 'Error', detail: 'Some error occured', life: 3000 });
            }
        } catch (e) {
            this.setState({ isLoading: false });
            this.toast?.show({ severity: 'error', summary: 'Error', detail: e.toString(), life: 3000 });
        }

    };


    deleteDifferentialFee = (index) => {
        const updatedFeeTypes = this.state.transportFeeTypes.filter((_, i) => i !== index);
        this.setState({ transportFeeTypes: updatedFeeTypes });
    };

    handleInputChange = (index, field, value) => {
        const feeType = [...this.state.transportFeeTypes];
        feeType[index][field] = value;
        this.setState({ feeType });
    };


    handleRadioButtonChange = (option) => {
        this.setState({ pickupFee: option });
    }

    onHandleNavigate = (isContinue) => {
        const { application, examTest, registration } = this.state?.admissionSettingsInfo
        let createdId = this.state.createdId
        const { enquiry } = this.state;

        if (isContinue && createdId) {
            localStorage.setItem('enquiryId', createdId)
            localStorage.setItem('applicationId', createdId)
            if (application) {
                this.props.navigate('/application')
            }
            // Only go to exam if examTest is enabled AND user has checked the box
            else if (examTest && enquiry.admissionTest) {
                this.props.navigate('/addExam')
            } else if (registration) {
                this.props.navigate('/addRegistration')
            }
            else {
                this.props.navigate('/confirm-enrollment')
            }
        } else {
            !this.state.isEdit ? this.props.navigate('/enquiry') : this.setState({ isEdit: false }, () => this.props.onHandleClose())
        }
    }

    onClickSaveAndExit = (isContinue) => {
        const { application, examTest, registration, enrollment } = this.state?.admissionSettingsInfo
        const { enquiry, dob, parents, siblings, formValidations } = this.state // Add parents and siblings here
        // this.state.enquiry.parentEmailId = this.parent[0].parentEmailId // Ensure parentEmailId is set from parents array
        let dateOfBirth = dob;
        //  || new Date()
        enquiry.dob = convertUtc(dateOfBirth)
        const formStatus = isFormValid(createEnquiryFields, this.formFields.formValidations, trimObj(enquiry));

        let isCompleteFormValid = true;
        if (!formStatus.formValidations.isFormValid) {
            this.setState({
                formValidations: formStatus.formValidations,
            });
            isCompleteFormValid = false;
        }
        /**for testing */
        // isCompleteFormValid = true;

        if (!enquiry.academicCategory || !enquiry.academicSession || !enquiry.board || !enquiry.branch || !enquiry.grade || !enquiry.dob || !enquiry.gender) {
            this.toast.show({ severity: 'error', summary: 'Please fill all mandatory fields', detail: 'Please fill all mandatory fields', life: 3000 });
            return
        }

        if (!enquiry.previousBoard || !enquiry.previousSchool || !enquiry.previousGrade) {
            this.toast.show({ severity: 'error', summary: 'Please fill all previous education fields', detail: 'Please fill all previous education fields', life: 3000 });
            return
        }

        // !filter.test(enquiry?.emailId) || 
        let filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        if (!filter.test(parents[0]?.parentEmailId)) {
            this.toast.show({ severity: 'error', summary: 'Please check email id format', detail: 'Please check email id format', life: 3000 });
            return
        }

        if (!parents[0].parentType) {
            this.toast.show({ severity: 'error', summary: 'Please check parent relation', detail: 'Please check parent relation', life: 3000 });
            return
        }
        if (!parents[0]?.countryCode) {
            this.toast.show({ severity: 'error', summary: 'Please check parent country code', detail: 'Please check parent country code', life: 3000 });
            return
        }
        if (!parents[0]?.parentContact) {
            this.toast.show({ severity: 'error', summary: 'Please check parent contact no', detail: 'Please check parent contact no', life: 3000 });
            return
        }


        if (enquiry.transportRequired && !enquiry.requestedStop) {
            this.setState({
                formValidations: {
                    ...formValidations,
                    fields: {
                        ...formValidations.fields,
                        requestedStop: {
                            isValid: false,
                            errorMsg: 'Requested Stop is required when Transport is selected'
                        }
                    }
                }
            });
            this.toast.show({ severity: 'error', summary: 'Please enter Requested Stop.', detail: "Requested Stop is required when Transport is selected.", life: 3000 });
            return;
        }

        const academicSession = localStorage.getItem('userAcademicYear')
        const newEnquiry = { ...enquiry, academicSession }
        if (isCompleteFormValid) {

            let academicYear = this.state.academicSession.find(el => el?.value == this.state.enquiry?.academicSession)?.label
            let admissionCategoryName = this.state.academicCategory.find(el => el?.value == this.state.enquiry?.academicCategory)?.label
            let payload = newEnquiry
            // Only set stage to Enquiry if student is not already enrolled
            if (this.state.enquiry?.stage !== "Confirmed") {
                payload.stage = "Enquiry"
            }
            payload.currentStage = "Enquiry"
            payload.academicYearCode = academicYear
            payload.admissionCategoryName = admissionCategoryName
            payload.branchName = this.state?.selectedbranchName || ""
            payload.boardName = this.state?.selectedBoardName || ""
            let selectedClass = this.state?.classes?.find(el => el.classId == payload?.grade)
            payload.gradeName = selectedClass?.className
            payload.groupId = this.state.groupId

            // Add parents and siblings to payload
            payload.parents = parents
            payload.siblings = siblings

            // Check if only Enquiry and Enrollment stages are enabled (two-stage scenario)
            const enabledStagesCount = [application, examTest, registration, enrollment].filter(Boolean).length;
            const isTwoStageFlow = enabledStagesCount === 0 && enrollment; // Only enquiry and enrollment

            // Flag to generate applicationId when moving from enquiry to enrollment in two-stage flow
            if (isTwoStageFlow && isContinue && enrollment) {
                payload.generateApplicationId = true;
                console.log('Two-stage flow detected: Enquiry → Enrollment. Will generate applicationId.');
            }

            if (application && isContinue) {
                payload.stage = "Application"
            }
            else if (examTest && isContinue) {
                payload.stage = "Exam"
            } else if (registration && isContinue) {
                payload.stage = "Registration"
                payload.registration = {
                    siblings: siblings, // Use the actual siblings data
                    prevAcademicDetails: [
                        { name: "", classStudied: "", schoolStudied: "", percentageOrGpa: "" }
                    ],
                }
            }
            else if (enrollment && isContinue) {
                payload.stage = "Enrollment"
            }

            this.setState({
                isLoading: true
            });

            // Rest of the method remains the same...
            if (!this.props?.selectedEnquiry?._id) {
                const url = `${baseUrlAdmin}/admissions`

                this.service.post(url, payload, true).then(res => {
                    if (res && res.status && res.res.status) {
                        this.setState({
                            isLoading: false,
                            createdId: res?.res?.data
                        }, () => { this.onHandleNavigate(isContinue) });
                        this.toast.show({ severity: 'success', summary: 'Success', detail: res?.res?.message, life: 3000 });

                    } else {
                        this.setState({
                            isLoading: false
                        });
                        this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
                    }
                }).catch(e => {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: "Error", detail: 'Some error occured', life: 3000 });
                })
            } else {
                payload.currentStage = "Enquiry"
                // Only update stage if student is not already enrolled
                if (this.props?.selectedEnquiry?.stage !== "Confirmed") {
                    // Keep the stage that was set earlier in the flow
                }
                payload._id = this.props?.selectedEnquiry?._id
                const url = `${baseUrlAdmin}/admissions/update`
                this.service.put(url, payload, true).then(res => {
                    if (res && res.status && res.res.status) {
                        this.setState({
                            isLoading: false,
                        }, () => { this.onHandleNavigate(isContinue) });
                        this.toast.show({ severity: 'success', summary: 'Success', detail: res?.res?.message, life: 3000 });

                    } else {
                        this.setState({
                            isLoading: false
                        });
                        this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
                    }
                }).catch(e => {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: "Error", detail: 'Some error occured', life: 3000 });
                })
            }
        } else {
            this.setState({
                isLoading: false
            });
            this.toast.show({ severity: 'error', summary: 'Please fill all the required fields.', detail: "Please fill all the required fields.", life: 3000 });
        }
    }



    // Helper method to remove duplicates based on unique ID
    removeDuplicates = (array, idKey) => {
        if (!array || array.length === 0) return [];

        const seen = new Set();
        return array.filter(item => {
            const id = item[idKey];
            if (seen.has(id)) {
                return false;
            }
            seen.add(id);
            return true;
        });
    }

    onChangeBranch = (branchId) => {
        this.setState({
            boards: [], classes: [],
        });
        let selectedbranchName = this.props.branchData?.find((branchd) => branchd.key == branchId)?.name;
        let filteredBoards = this.props.boards.filter(board => board.assignedBranches.includes(branchId));
        let boardsInfo = this.state.admissionSettingsInfo?.boards
        let finalBoardsList = []
        for (const sBoards of boardsInfo) {
            for (let i = 0; i < filteredBoards.length; i++) {
                const boardId = filteredBoards[i]?.boardId;
                if (sBoards === boardId) finalBoardsList.push(filteredBoards[i])

            }
        }
        // Remove duplicates
        finalBoardsList = this.removeDuplicates(finalBoardsList, 'boardId');

        this.setState({
            branchId: branchId,
            selectedbranchName: selectedbranchName,
            boards: finalBoardsList || [],
            classes: [],
            boardId: '',
            selectedBoardName: '',
            classId: '',
            selectedClass: {},
            branches: [],
            selectedClassName: '',
        });
    };


    onChangeBoard = (boardId) => {
        this.setState({
            classes: [], sections: [],
        });
        const selectedBoard = this.state.boards && this.props.boards.find((board) => board.boardId === boardId);
        let classesInfo = this.state.admissionSettingsInfo?.grades
        let finalClassesList = []
        for (const sClass of classesInfo) {
            for (let i = 0; i < selectedBoard?.classes.length; i++) {
                const classId = selectedBoard?.classes[i]?.classId;
                if (sClass === classId) finalClassesList.push(selectedBoard?.classes[i])
            }
        }
        // Remove duplicates from grades list
        finalClassesList = this.removeDuplicates(finalClassesList, 'classId');

        this.setState({
            classes: [],
            boardId,
            selectedBoardName: selectedBoard?.boardName,
            classId: '',
            selectedClass: {},
            branches: [],
            selectedClassName: '',
            selectedClassesList: finalClassesList
        }, () => this.getAgeCriteriaInfo(this.state?.branchId, this.state?.boardId, this.state.selectedClassesList));
    };

    // Handle state selection and filter districts
    onStateChange = (selectedState) => {
        // Get districts for selected state from districts.json
        const stateDistricts = districts[selectedState] || [];

        // Transform districts to dropdown format
        let transformedDistricts = stateDistricts.map(district => ({
            label: district,
            value: district
        }));

        // If no districts found for the selected state, add "Other" option
        if (transformedDistricts.length === 0) {
            transformedDistricts = [{ label: 'Other', value: 'Other' }];
        }

        // Update state with filtered districts and reset city/district selection
        this.setState(prevState => ({
            cityOrDist: transformedDistricts,
            enquiry: {
                ...prevState.enquiry,
                state: selectedState,
                cityOrDist: '' // Reset district selection when state changes
            }
        }), () => {
            // Call the standard form validation after state update
            onDropDownChange(
                selectedState,
                'state',
                this,
                formFields,
                this.state.enquiry,
                this.state.formValidations,
                'enquiry',
                'formValidations'
            );
        });
    };

    getAgeCriteriaInfo = async (branchId, boardId, finalClassesList) => {
        this.setState({
            isLoading: true
        });
        const { dob, enquiry, admissionSettingsInfo, ageCriteriaInfo } = this.state
        const academicYear = localStorage.getItem('userAcademicYear');
        let url = `${baseUrlAdmin}/admissions/agecriteria?boardId=${boardId}&branchId=${branchId}&academicYear=${academicYear}`;
        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {
                this.setState({ ageCriteriaInfo: res?.res?.data, isLoading: false }, () => this.onSetClasses(finalClassesList));
            } else {
                this.setState({ isLoading: false });
                this.toast.show({ severity: 'error', summary: 'Error', detail: res?.message, life: 3000 });
            }
        } catch (e) {
            console.log(e);
            this.setState({ isLoading: false });
            this.toast.show({ severity: 'error', summary: 'Error', detail: e.message, life: 3000 });
        }
    }

    onChangeClass = (classId) => {
        const { classes } = this.state
        let selectedClassId = classes.find(el => el.classId === classId)
        let groupId = selectedClassId?.groups[0]?.groupId
        let groupName = selectedClassId?.groups[0]?.groupName
        this.setState({
            groupId: groupId,
        })
    }

    onSetClasses = () => {
        const { dob, enquiry, ageCriteriaInfo, admissionSettingsInfo, selectedClassesList } = this.state
        if (admissionSettingsInfo?.ageCriteria) {
            let classesInfo
            if (dob && enquiry?.board) {
                // Check if age criteria data exists for the selected board
                if (!ageCriteriaInfo || ageCriteriaInfo.length === 0) {
                    // No age criteria configured for this board, show all grades
                    this.setState({
                        classes: selectedClassesList
                    });
                    return;
                }

                // Check if any grade has valid dates configured (not null/undefined)
                const hasValidDates = ageCriteriaInfo.some(cls =>
                    cls.bornBefore && cls.bornAfter &&
                    cls.bornBefore !== null && cls.bornAfter !== null
                );

                if (!hasValidDates) {
                    // Dates not configured for this board, show all grades
                    this.setState({
                        classes: selectedClassesList
                    });
                    return;
                }

                // Age criteria is configured with valid dates, filter based on DOB
                classesInfo = ageCriteriaInfo.filter(cls => {
                    // Skip grades without valid dates
                    if (!cls.bornBefore || !cls.bornAfter) return false;

                    const dateOfBirth = new Date(dob.toDateString());
                    const bornBeforeDate = new Date(new Date(cls.bornBefore).toDateString());
                    const bornAfterDate = new Date(new Date(cls.bornAfter).toDateString());

                    return dateOfBirth >= bornAfterDate && dateOfBirth <= bornBeforeDate;
                });
                const classIds = new Set(classesInfo.map(item => item.classId));


                const matchedClasses = selectedClassesList && selectedClassesList?.filter(item => classIds.has(item.classId));
                if (!matchedClasses.length) {
                    // Age criteria is configured but DOB doesn't match any grade - show error
                    this.setState({
                        isLoading: false,
                        classes: [],
                        enquiry: {
                            ...this.state.enquiry,
                            grade: ''
                        }
                    });
                    this.toast?.show({ severity: 'error', summary: 'Age not eligible for any grades', detail: "Age not eligible for any grades", life: 3000 });
                } else {
                    // Check if currently selected grade is still in the matched classes
                    const isSelectedGradeValid = matchedClasses.some(cls => cls.classId === this.state.enquiry.grade);

                    this.setState({
                        classes: matchedClasses,
                        enquiry: {
                            ...this.state.enquiry,
                            grade: isSelectedGradeValid ? this.state.enquiry.grade : ''
                        }
                    })
                }
            } else if (!dob) {
                this.setState({ isLoading: false });
                this.toast?.show({ severity: 'error', summary: 'Please select DOB', detail: "Please select DOB", life: 3000 });
            } else {
                this.setState({
                    classes: selectedClassesList
                })
            }

        } else {
            this.setState({
                classes: selectedClassesList
            })
        }


    }

    _onProgress = (progressInfo) => {
        // Handle upload progress
        console.log('Upload progress:', progressInfo);
    };
    _onFilsUploadError = (errMsg) => {
        this.toast.show({ severity: 'error', summary: 'Some error', detail: errMsg, life: 3000 });
    }

    _afterFilesUploaded = (files) => {
        // Handle files selection
        console.log('Files selected:', files);
    };

    _onFilesUploadError = (error) => {
        // Handle error through Toast
        console.error('Upload error:', error);
        this.toast.show({
            severity: 'error',
            summary: 'Upload Error',
            detail: error.message || 'File upload failed',
            life: 3000
        });
    };


    addAttachment = (fieldName, fileName, data) => {
        this.setState((prevState) => ({
            enquiry: {
                ...prevState.enquiry,
                [fieldName]: {
                    fileName,
                    storageBucket: data.Bucket,
                    storageKey: data.Key,
                    storageLocation: data.Location,
                }
            }
        }));
    }
    _onStudentPhotoSuccess = (fileName, data) => {
        // Use local method to update student photo
        this.addAttachment('studentPhoto', fileName, data);
    };

    onChangeInput = (value, index, field, arr) => {
        if (arr === "siblings") {
            let data = [...this.state.siblings];
            data[index][field] = value;
            this.setState({ siblings: data });
        }
    };

    onCliclAddSibling = (add, index) => {
        if (add) {
            let arrLength = this.state.siblings.length;
            let lastObj = this.state.siblings[arrLength - 1];
            if (lastObj.name !== "") {
                this.setState((prevState) => ({
                    siblings: [...prevState.siblings, { name: "", gender: "", classStudying: "", schoolStudying: "" }]
                }));
            } else {
                this.toast.show({ severity: 'error', summary: 'Please enter the sibling details', detail: '', life: 3000 });
            }
        } else {
            const { siblings } = this.state;
            if (siblings.length > 1) {
                const newArr = [...siblings];
                newArr.splice(index, 1);
                this.setState({ siblings: newArr });
            }
        }
    };

    onAcademicYearChange = async (academicYearId) => {
        // Update localStorage first
        localStorage.setItem('userAcademicYear', academicYearId);

        // Trigger a custom event to notify AppTopbar of the change
        window.dispatchEvent(new CustomEvent('academicYearChanged', {
            detail: { academicYearId }
        }));

        // Refresh data that depends on academic year
        await this.refreshAcademicYearDependentData();
    };

    refreshAcademicYearDependentData = async () => {
        // Re-fetch data that depends on academic year
        try {
            await Promise.all([
                this.getAdmissionSettingsInfo(),
                this.getCouncellorsInfo(),
                this.getAdmissionTypeDropdown()
            ]);
        } catch (error) {
            console.error('Error refreshing academic year dependent data:', error);
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to refresh data for selected academic year',
                life: 3000
            });
        }
    };

    addParent = () => {
        this.setState((prevState) => ({
            parents: [
                ...prevState.parents,
                {
                    parentType: '',
                    parentName: '',
                    qualification: '',
                    profession: '',
                    countryCode: '', // Add this
                    // contact: '',     // Add this
                    // email: ''        // Add this
                    parentContact: '',
                    parentEmailId: '',
                }
            ],
            parentValidations: [...prevState.parentValidations, {}]
        }));
    };
    removeParent = (index) => {
        this.setState((prevState) => {
            const updatedParents = [...prevState.parents];
            updatedParents.splice(index, 1);
            const updatedValidations = prevState.parentValidations.filter((_, i) => i !== index);
            return { parents: updatedParents, parentValidations: updatedValidations };
        });
    };

    // Contact number validation - exactly 10 digits
    onContactNumberChange = (value, fieldName) => {
        const numericValue = value.replace(/\D/g, '').slice(0, 10);

        let validation = { isValid: true, errorMsg: '' };

        if (numericValue && numericValue.length < 10) {
            validation = {
                isValid: false,
                errorMsg: 'Contact number must be exactly 10 digits'
            };
        } else if (numericValue && numericValue.length === 10) {
            validation = {
                isValid: true,
                errorMsg: ''
            };
        }

        this.setState(prevState => ({
            enquiry: {
                ...prevState.enquiry,
                [fieldName]: numericValue
            },
            formValidations: {
                ...prevState.formValidations,
                fields: {
                    ...prevState.formValidations.fields,
                    [fieldName]: validation
                }
            }
        }));
    };

    // Email validation with proper format check
    onEmailChangeWithValidation = (value, fieldName) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        let validation = { isValid: true, errorMsg: '' };

        if (value && !emailRegex.test(value)) {
            validation = {
                isValid: false,
                errorMsg: 'Please enter a valid email address'
            };
        } else if (value) {
            validation = {
                isValid: true,
                errorMsg: ''
            };
        }

        this.setState(prevState => ({
            enquiry: {
                ...prevState.enquiry,
                [fieldName]: value
            },
            formValidations: {
                ...prevState.formValidations,
                fields: {
                    ...prevState.formValidations.fields,
                    [fieldName]: validation
                }
            }
        }));
    };

    // Pincode validation - exactly 6 digits
    onPincodeChange = (value) => {
        const numericValue = value.replace(/\D/g, '').slice(0, 6);

        let validation = { isValid: true, errorMsg: '' };

        if (numericValue && numericValue.length < 6) {
            validation = {
                isValid: false,
                errorMsg: 'Pincode must be exactly 6 digits'
            };
        } else if (numericValue && numericValue.length === 6) {
            validation = {
                isValid: true,
                errorMsg: ''
            };
        }

        this.setState(prevState => ({
            enquiry: {
                ...prevState.enquiry,
                pinCode: numericValue
            },
            formValidations: {
                ...prevState.formValidations,
                fields: {
                    ...prevState.formValidations.fields,
                    pinCode: validation
                }
            }
        }));
    };

    onParentChange = (value, index, field) => {
        const updatedParents = [...this.state.parents];
        let validationError = null;

        // Apply validation for specific fields
        if (field === 'parentContact') {
            const numericValue = value.replace(/\D/g, '').slice(0, 10);
            updatedParents[index][field] = numericValue;

            if (numericValue && numericValue.length < 10) {
                validationError = 'Contact number must be exactly 10 digits';
            }
        } else if (field === 'parentEmailId') {
            updatedParents[index][field] = value;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (value && !emailRegex.test(value)) {
                validationError = 'Please enter a valid email address';
            }
        } else {
            updatedParents[index][field] = value;
        }

        // Update parent validations
        const updatedParentValidations = [...this.state.parentValidations];
        if (!updatedParentValidations[index]) {
            updatedParentValidations[index] = {};
        }
        updatedParentValidations[index][field] = {
            isValid: !validationError,
            errorMsg: validationError || ''
        };

        // Update the main enquiry object with the first parent's data
        const updatedEnquiry = { ...this.state.enquiry };
        if (index === 0) {
            // Sync first parent's data to enquiry object for validation and backward compatibility
            if (field === 'parentType') updatedEnquiry.parentType = value;
            if (field === 'parentName') updatedEnquiry.parentName = value;
            if (field === 'parentContact') {
                // Use the validated/formatted value from updatedParents
                updatedEnquiry.parentContact = updatedParents[0][field];
                updatedEnquiry.contactNo = updatedParents[0][field]; // Backward compatibility
            }
            if (field === 'parentEmailId') {
                updatedEnquiry.parentEmailId = value;
                updatedEnquiry.emailId = value; // Backward compatibility
            }
            if (field === 'countryCode') {
                updatedEnquiry.countryCode = value;
            }
        }

        // Update form validations for the first parent
        const updatedFormValidations = { ...this.state.formValidations };
        if (index === 0 && this.formFields.formValidations.fields[field]) {
            updatedFormValidations.fields[field] = {
                isValid: !validationError,
                errorMsg: validationError || ''
            };
        }

        this.setState({
            parents: updatedParents,
            parentValidations: updatedParentValidations,
            enquiry: updatedEnquiry,
            formValidations: updatedFormValidations
        });
    };

    // First, add the refreshAcademicSessions method that's being called in onFocus
    refreshAcademicSessions = async () => {
        await this.getAcademicSessions();
    };

    // Add a method to validate ID details based on the selected govt ID type
    validateIdDetails = (value, govtIdType) => {
        if (!value) return { isValid: true, errorMsg: '' }; // Allow empty for optional field

        switch (govtIdType) {
            case 'aadhaar':
                // Aadhaar: exactly 12 digits
                const aadhaarRegex = /^\d{12}$/;
                if (!aadhaarRegex.test(value)) {
                    return {
                        isValid: false,
                        errorMsg: 'Aadhaar number must be exactly 12 digits'
                    };
                }
                break;
            case 'passport':
                // Passport: exactly 8 alphanumeric characters
                const passportRegex = /^[A-Za-z0-9]{8}$/;
                if (!passportRegex.test(value)) {
                    return {
                        isValid: false,
                        errorMsg: 'Passport number must be exactly 8 alphanumeric characters'
                    };
                }
                break;
            default:
                return { isValid: true, errorMsg: '' };
        }

        return { isValid: true, errorMsg: '' };
    };

    // Add a method to handle ID details change with validation
    onIdDetailsChange = (value) => {
        const { enquiry } = this.state;
        const validation = this.validateIdDetails(value, enquiry.govtIdType);

        // Update the enquiry state
        this.setState(prevState => ({
            enquiry: {
                ...prevState.enquiry,
                idDetails: value
            },
            formValidations: {
                ...prevState.formValidations,
                fields: {
                    ...prevState.formValidations.fields,
                    idDetails: validation
                }
            }
        }));
    };

    // Add a method to handle govt ID type change
    onGovtIdTypeChange = (value) => {
        const { enquiry } = this.state;

        // Clear ID details when changing govt ID type
        this.setState(prevState => ({
            enquiry: {
                ...prevState.enquiry,
                govtIdType: value,
                idDetails: '' // Clear the ID details when type changes
            },
            formValidations: {
                ...prevState.formValidations,
                fields: {
                    ...prevState.formValidations.fields,
                    govtIdType: { isValid: true, errorMsg: '' },
                    idDetails: { isValid: true, errorMsg: '' }
                }
            }
        }));
    };

    render() {
        const { enquiry, formValidations } = this.state;
        return (
            <>
                <div className=''>
                    <br />
                    <div className='ml-6'>
                        <h1 className='text-2xl font-bold text-black mb-2' style={{ color: 'black' }}>
                            <u>Academic Details</u>
                        </h1>
                    </div>

                    {/* Admission Year, Academic Category */}
                    <div className="grid  md:col-12 lg:rid-col-12 mx-5 column-gap-8 row-gap-5" >
                        {/* Academic Year dropdown to use the same data source as AppTopbar */}
                        <div className="col-span-1">
                            <p className='transport-fee-form-label'>Academic Year<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                {(this.props.academicYearOptions?.length || this.state.academicSession?.length) ? (
                                    <ClassetDropdown
                                        width={250}
                                        height={48}
                                        optionLabel='academicCode'
                                        optionValue='_id'
                                        className='text-xl add-vehicle-field-input w-full'
                                        value={enquiry.academicSession}
                                        options={this.props.academicYearOptions?.length ? this.props.academicYearOptions : this.state.academicSession}
                                        showClear={false}
                                        onFocus={() => {
                                            // Refresh academic sessions when dropdown is focused
                                            this.refreshAcademicSessions();
                                        }}
                                        onChange={(e) => {
                                            // Update localStorage for AppTopbar sync
                                            localStorage.setItem('userAcademicYear', e.target.value);

                                            // Trigger custom event for AppTopbar to listen
                                            window.dispatchEvent(new CustomEvent('academicYearChanged', {
                                                detail: { academicYearId: e.target.value }
                                            }));

                                            // Update form state
                                            onDropDownChange(e.target.value, 'academicSession', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations');

                                            // Refresh dependent data
                                            this.onAcademicYearChange(e.target.value);
                                        }}
                                        placeholder='Select Academic Year'
                                    />
                                ) : (
                                    <div className="flex align-items-center justify-content-center" style={{ width: 250, height: 48 }}>
                                        <ProgressSpinner style={{ width: '24px', height: '24px' }} strokeWidth="4" fill="var(--surface-ground)" animationDuration=".5s" />
                                    </div>
                                )}
                            </div>
                            {formValidations && !formValidations.fields['academicSession']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['academicSession']?.errorMsg}</p>
                            )}
                        </div>
                        {/* Admission Category dropdown */}
                        <div className="col-span-1">
                            <p className='transport-fee-form-label'>Admission Category<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    height={48}
                                    //
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enquiry.academicCategory}
                                    options={this.state.academicCategory}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'academicCategory', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations') }}
                                    placeholder='Admission Category'
                                // required={false}

                                />
                            </div>
                            {formValidations && !formValidations.fields['academicCategory'].isValid && <p className="p-error text-lg">{formValidations.fields['academicCategory'].errorMsg}</p>}
                        </div>
                    </div>

                    {/* Branch board grade */}
                    <div className="grid  md:col-12 lg:rid-col-12 mx-5 column-gap-8 row-gap-5" >
                        <div className="col-span-1">
                            <p className='transport-fee-form-label'>Branch<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    height={48}
                                    //
                                    optionLabel='name'
                                    optionValue='key'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enquiry.branch}
                                    options={this.props.branchData}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'branch', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations'); this.onChangeBranch(e.target.value) }}
                                    placeholder='Select Branch'
                                // required={true}
                                />
                            </div>
                            {formValidations && !formValidations.fields['branch'].isValid && <p className="p-error text-lg">{formValidations.fields['branch'].errorMsg}</p>}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Board<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    //
                                    optionLabel='boardName'
                                    optionValue='boardId'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enquiry.board}
                                    options={this.state.boards}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'board', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations'); this.onChangeBoard(e.target.value) }}
                                    placeholder='Select Board'
                                />
                            </div>
                            {formValidations && !formValidations.fields['board'].isValid && <p className="p-error text-lg">{formValidations.fields['board'].errorMsg}</p>}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Grade<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    //
                                    optionLabel='className'
                                    optionValue='classId'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enquiry.grade}
                                    options={this.state?.classes}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'grade', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations'); this.onChangeClass(e.target.value) }}
                                    placeholder='Select Grade'
                                />
                            </div>
                            {formValidations && !formValidations.fields['grade'].isValid && <p className="p-error text-lg">{formValidations.fields['grade'].errorMsg}</p>}
                        </div>
                    </div>

                    {/* Prev  Branch board grade */}
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5"  >
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Previous School<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    //
                                    className=' add-vehicle-field-input w-full '
                                    value={enquiry.previousSchool}
                                    onChange={(e) => onTextChange(e.target.value, 'previousSchool', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations')}
                                    placeholder="Previous School" />
                            </div>
                            {formValidations && !formValidations.fields['previousSchool'].isValid && <p className="p-error text-lg">{formValidations.fields['previousSchool'].errorMsg}</p>}
                        </div>
                        <div className="col-span-1 ">

                            <p className='transport-fee-form-label'>Previous Board<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enquiry.previousBoard}
                                    options={this.state.previousBoards}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'previousBoard', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations') }}
                                    placeholder='Select Previous Board'
                                />
                            </div>
                            {formValidations && !formValidations.fields['previousBoard'].isValid && <p className="p-error text-lg">{formValidations.fields['previousBoard'].errorMsg}</p>}
                        </div>


                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Previous Grade<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enquiry.previousGrade}
                                    options={this.state.classStudyingDrp}
                                    onChange={(e) => {
                                        onDropDownChange(e.target.value, 'previousGrade', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations');
                                    }}
                                    placeholder='Select Previous Grade'
                                />
                            </div>
                            {formValidations && !formValidations.fields['previousGrade']?.isValid && <p className="p-error text-lg">{formValidations.fields['previousGrade']?.errorMsg}</p>}
                        </div>
                    </div>

                    {/* Student | Personal Details */}
                    <br />
                    <div className='ml-6 mt-5'>
                        <h1 className='text-2xl font-bold text-black mb-2' style={{ color: 'black' }}>
                            <u>Personal Details</u>
                        </h1>
                    </div>
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5"  >
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Student First Name<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    //
                                    // id="title"
                                    width={250}
                                    className='  add-vehicle-field-input w-full '
                                    value={enquiry.firstName}
                                    onChange={(e) => {
                                        if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                                            onTextChange(e.target.value, 'firstName', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations');
                                        }
                                    }}
                                    placeholder="Student First Name" />
                            </div>
                            {formValidations && !formValidations.fields['firstName'].isValid && <p className="p-error text-lg">{formValidations.fields['firstName'].errorMsg}</p>}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Student Middle Name</p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    className='add-vehicle-field-input w-full'
                                    value={enquiry.middleName} // Corrected field
                                    onChange={(e) => {
                                        if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                                            onTextChange(e.target.value, 'middleName', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations'); // Corrected field
                                        }
                                    }}
                                    placeholder="Student Middle Name"
                                />
                            </div>
                            {formValidations && !formValidations.fields['middleName']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['middleName']?.errorMsg}</p> // Corrected field
                            )}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Student Last Name<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    //
                                    // id="title"
                                    width={250}
                                    className='  add-vehicle-field-input w-full '
                                    value={enquiry.lastName}
                                    onChange={(e) => {
                                        if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                                            onTextChange(e.target.value, 'lastName', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations')
                                        }
                                    }}
                                    placeholder="Student Last Name" />
                            </div>
                            {formValidations && !formValidations.fields['lastName'].isValid && <p className="p-error text-lg">{formValidations.fields['lastName'].errorMsg}</p>}
                        </div>
                    </div>

                    {/* Gender, DOB, Upload photo */}
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5"  >
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Gender<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}

                                    //
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enquiry.gender}
                                    options={this.state.gender}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'gender', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations') }}
                                    placeholder='Select Gender'
                                />
                            </div>
                            {formValidations && !formValidations.fields['gender'].isValid && <p className="p-error text-lg">{formValidations.fields['gender'].errorMsg}</p>}

                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Date of Birth<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetCalendar
                                    width={250}
                                    //
                                    className=' border-round-md add-vehicle-field-input text-xl w-full'
                                    calendarMode={'single'}
                                    value={this.state.dob}
                                    // value={enquiry.dob ? new Date(enquiry.dob) : new Date()}
                                    onChange={(e) => {
                                        this.setState({
                                            dob: e.value,
                                            enquiry: { ...this.state.enquiry, dob: e.value }
                                        }, () => this.onSetClasses())
                                    }}
                                    placeholder="DOB"
                                    maxDate={new Date()}
                                />
                            </div>
                        </div>
                        <div className="col-span-1">
                            <p className="transport-fee-form-label">
                                Upload Photo
                            </p>
                            <div className="flex">
                                <FileUpload
                                    id={'student'}
                                    multiple={false}
                                    onProgress={this._onProgress}
                                    onSucess={this._onStudentPhotoSuccess} // Note: It's 'onSucess' not 'onSuccess' (matching registration.js)
                                    maxFileSize={5242880} // 5MB in bytes
                                    onError={this._onFilesUploadError} // Note: It's '_onFilsUploadError' not '_onFilesUploadError' (matching registration.js)
                                    accept={'images'} // Changed to 'images' to match registration.js
                                    title={'Upload Student Photo'}
                                    afterFilesUploaded={this._afterFilesUploaded}
                                    className="border-solid"
                                    disabled={this.state.isLoading}
                                >
                                    <ClassetInputText
                                        width={250}
                                        icon={<FileAttachmentIcon width={24} height={24} color={'black'} />}
                                        className="add-vehicle-field-input w-full"
                                        value={enquiry.studentPhoto?.fileName || ''}
                                        placeholder="Upload Photo"
                                        disabled={true}
                                    />
                                </FileUpload>
                            </div>
                            {formValidations && !formValidations.fields['studentPhoto']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['studentPhoto']?.errorMsg}</p>
                            )}
                        </div>
                    </div>

                    {/* Nationality, Govt Id, id details */}
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5"  >
                        {/* nationality */}
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Nationality</p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='name'
                                    optionValue='code'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enquiry.nationality}
                                    options={this.state.countries}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'nationality', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations') }}
                                    placeholder='Select Nationality'
                                />
                            </div>
                            {formValidations && !formValidations.fields['nationality']?.isValid && <p className="p-error text-lg">{formValidations.fields['nationality']?.errorMsg}</p>}
                        </div>


                        {/* Gov ID */}
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Govt ID</p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enquiry.govtIdType}
                                    options={this.state.govtIdTypes}
                                    onChange={(e) => {
                                        this.onGovtIdTypeChange(e.target.value);
                                    }}
                                    placeholder='Select Govt ID'
                                />
                            </div>
                            {formValidations && !formValidations.fields['govtIdType']?.isValid && <p className="p-error text-lg">{formValidations.fields['govtIdType']?.errorMsg}</p>}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>ID Details</p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    keyfilter={enquiry.govtIdType === 'aadhaar' ? 'int' : null} // Only allow numbers for Aadhaar
                                    maxLength={enquiry.govtIdType === 'aadhaar' ? 12 : enquiry.govtIdType === 'passport' ? 8 : undefined}
                                    className='add-vehicle-field-input w-full'
                                    value={enquiry.idDetails}
                                    onChange={(e) => {
                                        let value = e.target.value;

                                        // Apply specific filters based on govt ID type
                                        if (enquiry.govtIdType === 'aadhaar') {
                                            // Only allow digits for Aadhaar
                                            value = value.replace(/\D/g, '');
                                            if (value.length > 12) value = value.slice(0, 12);
                                        } else if (enquiry.govtIdType === 'passport') {
                                            // Only allow alphanumeric for Passport
                                            value = value.replace(/[^A-Za-z0-9]/g, '');
                                            if (value.length > 8) value = value.slice(0, 8);
                                            value = value.toUpperCase(); // Convert to uppercase for consistency
                                        }

                                        this.onIdDetailsChange(value);
                                    }}
                                    placeholder={
                                        enquiry.govtIdType === 'aadhaar' ? "Enter Aadhaar number"
                                            : enquiry.govtIdType === 'passport'
                                                ? "Enter Passport number"
                                                : "Enter ID Details"
                                    }
                                    disabled={!enquiry.govtIdType} // Disable if no govt ID type is selected
                                />
                            </div>
                            {formValidations && !formValidations.fields['idDetails']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['idDetails']?.errorMsg}</p>
                            )}
                            {/* Show format hint */}
                            {enquiry.govtIdType && (
                                <small className="p-text-secondary">
                                    {enquiry.govtIdType === 'aadhaar' && "Format: 12 digits (e.g., 123456789012)"}
                                    {enquiry.govtIdType === 'passport' && "Format: 8 alphanumeric characters (e.g., A1234567)"}
                                </small>
                            )}
                        </div>
                        <div className="">
                            <p className="transport-fee-form-label">Blood Group</p>
                            <div className="flex">
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    placeholder="Select Blood Group"
                                    className="add-vehicle-field-input"
                                    value={enquiry.bloodGroup}
                                    options={[
                                        { label: 'A+', value: 'A+' },
                                        { label: 'A-', value: 'A-' },
                                        { label: 'B+', value: 'B+' },
                                        { label: 'B-', value: 'B-' },
                                        { label: 'O+', value: 'O+' },
                                        { label: 'O-', value: 'O-' },
                                        { label: 'AB+', value: 'AB+' },
                                        { label: 'AB-', value: 'AB-' }
                                    ]}
                                    onChange={(e) => {
                                        this.setState(prevState => ({
                                            enquiry: {
                                                ...prevState.enquiry,
                                                bloodGroup: e.value
                                            }
                                        }));
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Religion, Mother Tongue, Caste */}
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5"  >

                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Religion</p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enquiry.religion}
                                    options={this.state.religions}
                                    onChange={(e) => onDropDownChange(e.target.value, 'religion', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations')}
                                    placeholder='Select Religion'
                                />
                            </div>
                            {formValidations && !formValidations.fields['religion']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['religion']?.errorMsg}</p>
                            )}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Mother Tongue<span className='ma-required'></span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    className='add-vehicle-field-input w-full'
                                    value={enquiry.motherTongue}
                                    // onChange={(e) => onTextChange(e.target.value, 'motherTongue', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations')}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/[^a-zA-Z\s]/g, ''); // Allow only letters and spaces
                                        onTextChange(value, 'motherTongue', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations');
                                    }}
                                    placeholder="Enter Language"
                                />
                            </div>
                            {formValidations && !formValidations.fields['motherTongue']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['motherTongue']?.errorMsg}</p>
                            )}
                        </div>
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Caste</p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enquiry.caste}
                                    options={this.state.castes}
                                    onChange={(e) => onDropDownChange(e.target.value, 'caste', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations')}
                                    placeholder='Select Caste'
                                />
                            </div>
                            {formValidations && !formValidations.fields['caste']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['caste']?.errorMsg}</p>
                            )}
                        </div>


                    </div>

                    <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5" >
                        {/* // The Country Code dropdown remains the same - it will now use the JSON data */}
                        <div className="col-span-1">
                            <p className='transport-fee-form-label'>Country Code</p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enquiry.stdCountryCode}
                                    options={this.state.countryPhoneCodes} // This now uses JSON data
                                    onChange={(e) => {
                                        onDropDownChange(e.target.value, 'stdCountryCode', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations');
                                    }}
                                    placeholder='Select Country Phone Code'
                                />
                            </div>
                            {formValidations && !formValidations.fields['stdCountryCode']?.isValid && <p className="p-error text-lg">{formValidations.fields['stdCountryCode']?.errorMsg}</p>}
                        </div>

                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Contact No</p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    keyfilter='int'
                                    maxLength={10}
                                    //
                                    className='  add-vehicle-field-input w-full '
                                    value={enquiry.stdContactNo}
                                    onChange={(e) => this.onContactNumberChange(e.target.value, 'stdContactNo')}
                                    placeholder="Contact No (10 digits)" />
                            </div>
                            {formValidations && !formValidations.fields['stdContactNo']?.isValid && <p className="p-error text-lg">{formValidations.fields['stdContactNo']?.errorMsg}</p>}
                        </div>
                        <div className="col-span-1">
                            <p className='transport-fee-form-label'>Email ID</p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={250}
                                    //
                                    className='  add-vehicle-field-input w-full '
                                    value={enquiry.stdEmailId}
                                    onChange={(e) => this.onEmailChangeWithValidation(e.target.value, 'stdEmailId')}
                                    placeholder="Email ID" />
                            </div>
                            {formValidations && !formValidations.fields['stdEmailId']?.isValid && <p className="p-error text-lg">{formValidations.fields['stdEmailId']?.errorMsg}</p>}
                        </div>
                        <div className="">
                            <p className="transport-fee-form-label">Current Location</p>
                            <div className="flex">
                                <ClassetInputText
                                    width={250}
                                    className="add-vehicle-field-input w-full"
                                    value={enquiry.currentLocation}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/[^a-zA-Z\s]/g, ''); // Allow only letters and spaces
                                        onTextChange(value, 'currentLocation', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations');
                                    }}
                                    placeholder="Enter Current Location"
                                />
                            </div>
                            {formValidations && !formValidations.fields['currentLocation']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['currentLocation']?.errorMsg}</p>
                            )}
                        </div>
                    </div>


                    <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5">
                        {/* <div className="grid md:col-12 lg:col-12 column-gap-8 row-gap-5 mx-5 my-2"> */}
                        <div className="">
                            <p className="transport-fee-form-label">Identification Marks</p>
                            <div className="flex">
                                <ClassetTextArea
                                    width={680}

                                    placeholder="Enter Identification Marks"
                                    className="add-vehicle-field-input w-full"
                                    // style={{ width: '100%' }} // Ensure full width
                                    value={enquiry.identificationMarks}
                                    onChange={(e) =>
                                        onTextChange(
                                            e.target.value,
                                            'identificationMarks',
                                            this,
                                            formFields,
                                            enquiry,
                                            formValidations,
                                            'enquiry',
                                            'formValidations'
                                        )
                                    }
                                />
                            </div>
                            {formValidations && !formValidations.fields['identificationMarks']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['identificationMarks']?.errorMsg}</p>
                            )}
                        </div>

                        {/* </div> */}
                    </div>

                    <div className='ml-6 mt-5'>
                        <h1 className='text-2xl font-bold text-black mb-1 ' style={{ color: 'black' }}>
                            <u>Parent Details</u>
                        </h1>
                    </div>
                    <br />
                    {/* PARENT DETAILS */}
                    {/* // Update the Parent Details section in the render method */}
                    {this.state.parents.map((parent, index) => (
                        <div key={index} className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5">
                            <div className="col-span-1">
                                <p className='transport-fee-form-label'>Relationship<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetDropdown
                                        width={250}
                                        optionLabel='label'
                                        optionValue='value'
                                        className='text-xl add-vehicle-field-input w-full'
                                        value={parent.parentType}
                                        options={this.state.parentTypes}

                                        // onChange={(e) => this.onParentChange(e.target.value, index, 'relationship')}
                                        onChange={(e) => { this.onParentChange(e.target.value, index, 'parentType', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations') }}

                                        placeholder='Relationship'
                                    />

                                </div>
                                {/* {enquiry.parentType = this.state.parents[0].parentType} */}
                                {formValidations && !formValidations.fields['parentType'].isValid && <p className="p-error text-lg">{formValidations.fields['parentType'].errorMsg}</p>}

                            </div>
                            <div className="col-span-1">
                                <p className='transport-fee-form-label'>Parent Name<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        className='add-vehicle-field-input w-full'
                                        value={parent.parentName}
                                        onChange={(e) => this.onParentChange(e.target.value, index, 'parentName', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations')}
                                        placeholder="Enter Parent Name"
                                    />

                                </div>
                                {/* {enquiry.parentName = this.state.parents[0].parentName} */}
                                {formValidations && !formValidations.fields['parentName'].isValid && <p className="p-error text-lg">{formValidations.fields['parentName'].errorMsg}</p>}

                            </div>
                            <div className="col-span-1">
                                <p className='transport-fee-form-label'>Qualification</p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        // keyfilter="alpha"
                                        className='add-vehicle-field-input w-full'
                                        value={parent.qualification}
                                        onChange={(e) => this.onParentChange(e.target.value, index, 'qualification')}
                                        placeholder="Enter Qualification"
                                    />
                                </div>
                            </div>
                            <div className="col-span-1">
                                <p className='transport-fee-form-label'>Profession</p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        // keyfilter="alpha"
                                        className='add-vehicle-field-input w-full'
                                        value={parent.profession}

                                        onChange={(e) => this.onParentChange(e.target.value, index, 'profession')}
                                        placeholder="Enter Profession"
                                    />
                                </div>
                            </div>


                            {/* Fix: Use parent-specific country code */}
                            {/* // Also update the Parent Details section to use the same JSON data */}
                            <div className="col-span-1">
                                <p className='transport-fee-form-label'>Country Code<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetDropdown
                                        width={250}
                                        optionLabel='label'
                                        optionValue='value'
                                        className='text-xl add-vehicle-field-input w-full'
                                        value={parent.countryCode}
                                        options={this.state.countryPhoneCodes} // This also uses JSON data now
                                        onChange={(e) => this.onParentChange(e.target.value, index, 'countryCode')}
                                        placeholder='Select Country Phone Code'
                                    />
                                </div>
                                {formValidations && !formValidations.fields['countryCode'].isValid && <p className="p-error text-lg">{formValidations.fields['countryCode'].errorMsg}</p>}
                            </div>

                            {/* Fix: Use parent-specific contact number */}
                            <div className="col-span-1 ">
                                <p className='transport-fee-form-label'>Parent/Guardian Contact No.<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        keyfilter='int'
                                        maxLength={10}
                                        className={`add-vehicle-field-input w-full ${index === 0 && formValidations && !formValidations.fields['parentContact']?.isValid ? 'p-invalid' : ''}`}
                                        value={parent.parentContact} // Changed from enquiry.parentContact to parent.contact
                                        onChange={(e) => this.onParentChange(e.target.value, index, 'parentContact')}
                                        placeholder="Contact No. (10 digits)"
                                    />
                                </div>
                                {this.state.parentValidations[index]?.parentContact && !this.state.parentValidations[index]?.parentContact?.isValid ? (
                                    <p className="p-error text-lg" style={{ color: '#e24c4c', marginTop: '0.25rem' }}>
                                        {this.state.parentValidations[index]?.parentContact?.errorMsg}
                                    </p>
                                ) : (index === 0 && formValidations && !formValidations.fields['parentContact']?.isValid && (
                                    <p className="p-error text-lg" style={{ color: '#e24c4c', marginTop: '0.25rem' }}>
                                        {formValidations.fields['parentContact'].errorMsg}
                                    </p>
                                ))}
                            </div>

                            {/* Fix: Use parent-specific email */}
                            <div className="col-span-1 ">
                                <p className='transport-fee-form-label'>Parent/Guardian Email ID<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        className={`add-vehicle-field-input w-full ${index === 0 && formValidations && !formValidations.fields['parentEmailId']?.isValid ? 'p-invalid' : ''}`}
                                        value={parent.parentEmailId} // Changed from enquiry.parentEmailId to parent.email
                                        onChange={(e) => this.onParentChange(e.target.value, index, 'parentEmailId')} // Updated to use parent-specific handler
                                        placeholder="Parent/Guardian Email ID"
                                    />
                                </div>
                                {/* {enquiry.parentEmailId = this.state.parents[0].parentEmailId} */}
                                {this.state.parentValidations[index]?.parentEmailId && !this.state.parentValidations[index]?.parentEmailId?.isValid ? (
                                    <p className="p-error text-lg" style={{ color: '#e24c4c', marginTop: '0.25rem' }}>
                                        {this.state.parentValidations[index]?.parentEmailId?.errorMsg}
                                    </p>
                                ) : (index === 0 && formValidations && !formValidations.fields['parentEmailId']?.isValid && (
                                    <p className="p-error text-lg" style={{ color: '#e24c4c', marginTop: '0.25rem' }}>
                                        {formValidations.fields['parentEmailId'].errorMsg}
                                    </p>
                                ))}
                            </div>

                            <div className="col-span-1 flex align-items-center">
                                <Button icon="pi pi-plus" aria-label="Add Parent" onClick={() => this.addParent()} style={{ marginRight: '5px' }} />
                                {this.state.parents.length > 1 && (
                                    <Button icon="pi pi-minus" aria-label="Remove Parent" onClick={() => this.removeParent(index)} />
                                )}
                            </div>
                        </div>
                    ))}

                    {/* Remarks */}
                    <div className="grid md:col-12 lg:col-12 column-gap-8 row-gap-5 mx-5 my-2">
                        <div className="" >
                            <p className="transport-fee-form-label">Remarks</p>
                            <div className="flex">
                                <ClassetTextArea
                                    placeholder='Remarks'
                                    className=""
                                    width={680}
                                    value={enquiry.remarks}
                                    onChange={(e) => onTextChange(e.target.value, 'remarks', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations')}
                                />
                            </div>
                            {formValidations && !formValidations.fields['remarks'].isValid && <p className="p-error text-lg">{formValidations.fields['remarks'].errorMsg}</p>}
                        </div>
                    </div>

                    {/* SIBLINGS */}
                    <div className='ml-6'>
                        <h1 className='text-2xl font-bold text-black mb-2' style={{ color: 'black' }}>
                            <u>Siblings</u>
                        </h1>
                    </div>
                    <br />
                    <div className='p-grid ma-w100p mx-5 ma-p20 mb-5'>
                        <DataTable ref={(el) => this.dt = el}
                            value={this.state.siblings}>
                            <Column header='Sl.No' className='ma-w100 ma-h100' body={(rowData, index) => {
                                return (<span>{index.rowIndex + 1}</span>)
                            }} />
                            <Column header="Name" body={(rowData, index) => {
                                return (
                                    <ClassetInputText
                                        value={this.state.siblings[index.rowIndex].name}
                                        width={250}
                                        placeholder="Enter Name"
                                        onChange={(e) => this.onChangeInput(e.target.value, index.rowIndex, "name", "siblings")}
                                    />
                                )
                            }} />
                            <Column header="Gender" body={(rowData, index) => {
                                return (
                                    <ClassetDropdown disabled={this.state.hideUpdateButton}
                                        options={this.state.genderData} optionLabel='label' optionValue='value'
                                        width={250}
                                        value={this.state.siblings[index.rowIndex].gender}
                                        onChange={(e) => this.onChangeInput(e.target.value, index.rowIndex, "gender", "siblings")}
                                        placeholder="Select Gender" />
                                )
                            }} />
                            <Column header="Class Studying" body={(rowData, index) => {
                                return (
                                    <ClassetDropdown disabled={this.state.hideUpdateButton}
                                        options={this.state.classStudyingDrp} optionLabel='label' optionValue='value'
                                        width={250}
                                        value={this.state.siblings[index.rowIndex].classStudying}
                                        onChange={(e) => this.onChangeInput(e.target.value, index.rowIndex, "classStudying", "siblings")}
                                        placeholder="Select Class" />
                                )
                            }} />
                            <Column header="School Studying" body={(rowData, index) => {
                                return (
                                    <ClassetInputText
                                        width={250}
                                        value={this.state.siblings[index.rowIndex].schoolStudying}
                                        placeholder="Enter School Studying"
                                        onChange={(e) => this.onChangeInput(e.target.value, index.rowIndex, "schoolStudying", "siblings")}
                                    />
                                )
                            }} />
                            <Column header="" body={(rowData, index) => {
                                return (
                                    <div className="flex flex-column align-items-center justify-content-center gap-2">
                                        <Button icon="pi pi-plus" aria-label="Increase" onClick={() => this.onCliclAddSibling(true, index.rowIndex)} />
                                        {this.state.siblings.length > 1 && <Button icon="pi pi-minus" aria-label="Decrease" onClick={() => this.onCliclAddSibling(false, index.rowIndex)} />}
                                    </div>
                                )
                            }} />
                        </DataTable>
                    </div>

                    {/* ADDRESS */}
                    <div className='ml-6'>
                        <h1 className='text-2xl font-bold text-black ' style={{ color: 'black' }}>
                            <u>Address</u>
                        </h1>
                    </div>
                    {/* <br /> */}
                    <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5" >
                        {/* Address Line */}
                        <div className="col-span-1">
                            <p className="transport-fee-form-label">
                                Address Line<span className="ma-required">*</span>
                            </p>
                            <div className="flex">
                                <ClassetInputText
                                    width={1300}
                                    // style={{ width: '100vw' }} // Updated to use 100%
                                    className="add-vehicle-field-input w-full"
                                    value={enquiry.addressLine}
                                    onChange={(e) =>
                                        onTextChange(
                                            e.target.value,
                                            'addressLine',
                                            this,
                                            formFields,
                                            enquiry,
                                            formValidations,
                                            'enquiry',
                                            'formValidations'
                                        )
                                    }
                                    placeholder="Enter Address Line"
                                />
                            </div>
                            {formValidations && !formValidations.fields['addressLine']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['addressLine']?.errorMsg}</p>
                            )}
                        </div>
                    </div>


                    {/* state, district, pincode */}
                    <div className="grid  md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5" >
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Pincode<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    className='add-vehicle-field-input w-full'
                                    value={enquiry.pinCode}
                                    width={250}
                                    onChange={(e) => this.onPincodeChange(e.target.value)}
                                    placeholder="Enter Pincode (6 digits)"
                                    keyfilter='int'
                                    maxLength={6}
                                />
                            </div>
                            {formValidations && !formValidations.fields['pinCode']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['pinCode']?.errorMsg}</p>
                            )}
                        </div>
                        {/* state */}
                        <div className="col-span-1  ">
                            <p className='transport-fee-form-label'>State<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    className='add-vehicle-field-input w-full'
                                    value={enquiry.state}
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    options={this.state.state}
                                    onChange={(e) => this.onStateChange(e.target.value)}
                                    placeholder="Select State"
                                />
                            </div>
                            {formValidations && !formValidations.fields['state']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['state']?.errorMsg}</p>
                            )}
                        </div>

                        {/* City/District */}
                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>City/District<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    className='add-vehicle-field-input w-full'
                                    value={enquiry.cityOrDist}
                                    width={250}
                                    optionLabel='label'
                                    optionValue='value'
                                    options={this.state.cityOrDist} // Add the options from state
                                    onChange={(e) =>
                                        onDropDownChange(
                                            e.target.value,
                                            'cityOrDist',
                                            this,
                                            formFields,
                                            enquiry,
                                            formValidations,
                                            'enquiry',
                                            'formValidations'
                                        )
                                    }
                                    placeholder="Select City/District"
                                />
                            </div>
                            {formValidations && !formValidations.fields['cityOrDist']?.isValid && (
                                <p className="p-error text-lg">{formValidations.fields['cityOrDist']?.errorMsg}</p>
                            )}
                        </div>


                    </div>

                    <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5">

                    </div>


                    <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5">
                        {/* Transport Required Checkbox */}
                        <div className="col-span-1 flex align-items-center">
                            <input
                                type="checkbox"
                                id="transportRequired"
                                checked={!!enquiry.transportRequired}
                                onChange={(e) => {
                                    const checked = e.target.checked;
                                    this.setState({
                                        enquiry: {
                                            ...enquiry,
                                            transportRequired: checked,
                                            requestedStop: checked ? enquiry.requestedStop : '' // Clear requestedStop if unchecked
                                        }
                                    });
                                    // Optionally, clear validation error for requestedStop when unchecked
                                    if (!checked) {
                                        this.setState(prevState => ({
                                            formValidations: {
                                                ...prevState.formValidations,
                                                fields: {
                                                    ...prevState.formValidations.fields,
                                                    requestedStop: {
                                                        isValid: true,
                                                        errorMsg: ''
                                                    }
                                                }
                                            }
                                        }));
                                    }
                                }}
                                style={{ width: 18, height: 18, marginRight: 8 }}
                            />
                            <label htmlFor="transportRequired" className='transport-fee-form-label'>Transport Required</label>
                        </div>

                        {/* Admission Test Checkbox */}
                        {/* Admission Test Checkbox - only show if examTest is enabled in admission process */}
                        {this.state.admissionSettingsInfo?.examTest && (
                            <div className="col-span-1 flex align-items-center ml-8 ">
                                <input
                                    className='ml-4'
                                    type="checkbox"
                                    id="admissionTest"
                                    checked={!!enquiry.admissionTest}
                                    onChange={(e) =>
                                        this.setState({
                                            enquiry: {
                                                ...enquiry,
                                                admissionTest: e.target.checked
                                            }
                                        })
                                    }
                                    style={{ width: 18, height: 18, marginRight: 8 }}
                                />
                                <label htmlFor="admissionTest" className='transport-fee-form-label '>Admission Test</label>
                            </div>
                        )}
                    </div>

                    {/* Conditionally Render Requested Stop Dropdown */}
                    {enquiry.transportRequired && (
                        // ...existing code...

                        <div className="grid md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5">
                            <div className="">
                                <p className='transport-fee-form-label'>Requested Stop<span className='ma-required'>*</span></p>
                                <div className='flex'>
                                    <ClassetInputText
                                        width={250}
                                        className='add-vehicle-field-input w-full'
                                        value={enquiry.requestedStop}
                                        onChange={(e) =>
                                            onTextChange(
                                                e.target.value,
                                                'requestedStop',
                                                this,
                                                formFields,
                                                enquiry,
                                                formValidations,
                                                'enquiry',
                                                'formValidations'
                                            )
                                        }
                                        placeholder='Enter Requested Stop'
                                    />
                                </div>
                                {formValidations && !formValidations.fields['requestedStop']?.isValid && (
                                    <p className="p-error text-lg">{formValidations.fields['requestedStop']?.errorMsg}</p>
                                )}
                            </div>
                        </div>

                    )}

                    <div className="grid mt-5 md:col-12 lg:col-12 mx-5 column-gap-8 row-gap-5" >

                        <div className="">
                            <p className='transport-fee-form-label'>How did you know about us?<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={380}

                                    //
                                    optionLabel='label'
                                    optionValue='value'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enquiry.knowAboutUs}
                                    options={this.state.knowAboutUs}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'knowAboutUs', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations') }}
                                    placeholder='Select '
                                />
                            </div>
                            {formValidations && !formValidations.fields['knowAboutUs'].isValid && <p className="p-error text-lg">{formValidations.fields['knowAboutUs'].errorMsg}</p>}

                        </div>
                        <div className=" ">
                            <p className='transport-fee-form-label'>Reference Counsellors Name<span className='ma-required'></span></p>
                            <div className='flex'>
                                <ClassetInputText
                                    width={380}

                                    //
                                    className=' add-vehicle-field-input w-full '
                                    value={enquiry.counsellorsName}
                                    onChange={(e) => onTextChange(e.target.value, 'counsellorsName', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations')}
                                    placeholder="Enter Counsellor Name" />
                            </div>
                        </div>

                        <div className="col-span-1 ">
                            <p className='transport-fee-form-label'>Assigned Counsellor<span className='ma-required'>*</span></p>
                            <div className='flex'>
                                <ClassetDropdown
                                    width={380}

                                    //
                                    optionLabel='userName'
                                    optionValue='user_id'
                                    className='text-xl add-vehicle-field-input w-full'
                                    value={enquiry.assignCounsellor}

                                    options={this.state.counsellorInfo}
                                    onChange={(e) => { onDropDownChange(e.target.value, 'assignCounsellor', this, formFields, enquiry, formValidations, 'enquiry', 'formValidations') }}
                                    placeholder='Select'
                                />
                            </div>
                            {formValidations && !formValidations.fields['assignCounsellor'].isValid && <p className="p-error text-lg">{formValidations.fields['assignCounsellor'].errorMsg}</p>}

                        </div>

                        {enquiry?.customFields && Array.isArray(enquiry?.customFields) && enquiry?.customFields.length > 0 && <PopulateDynamicForm fieldArray={enquiry?.customFields} />}

                    </div>

                    <div className="text-center mt-8">
                        <Button
                            // icon={'pi pi-plus-circle text-lg '} 
                            label={!this.state.isEdit ? 'Save' : 'Save'} onClick={() => this.onClickSaveAndExit(false)} className='confirmDialogAcceptBtn  mr-5 w-18rem p-5' />
                        {!this.state.isEdit && <Button

                            // icon={'pi pi-plus-circle text-lg '} 
                            label='Save and Proceed to Next Step' onClick={() => this.onClickSaveAndExit(true)} className='confirmDialogAcceptBtn  mr-5 w-24rem p-5' />}
                        <Button label='Cancel'
                            style={{
                                background: '#E6E8EA', border: '0px', borderRadius: '12px', maxHeight: '48px', width: '120px', font: "InterSemiBold !important",
                                fontSize: '16px', color: 'black'
                            }}
                            className='confirmDialogCancelBtn p-5' onClick={() => !this.state.isEdit ? this.props.navigate('/enquiry') : this.setState({ isEdit: false, application: this.formFields.data }, () => this.props.onHandleClose())} />

                    </div>
                </div >

                {/* Age Criteria DOB Modal */}
                <Dialog
                    visible={this.state.showAgeCriteriaDobModal}
                    modal
                    closable={false}
                    showHeader={false}
                    style={{ width: '500px', borderRadius: '12px' }}
                    contentStyle={{ borderRadius: '12px' }}
                    draggable={false}
                    blockScroll={true}
                >
                    <div className="p-4">
                        <p className="text-lg mb-4" style={{ color: '#495057', lineHeight: '1.6' }}>
                            {/* Age Criteria is required. Please ensure that the age criteria is met before proceeding with the enquiry. */}
                            Please enter Date of Birth to view eligible grades.
                        </p>

                        <div className="mt-4">
                            <p className='transport-fee-form-label mb-2'>
                                Date of Birth<span className='ma-required'>*</span>
                            </p>
                            <ClassetCalendar
                                width={'100%'}
                                className='border-round-md add-vehicle-field-input text-xl w-full'
                                calendarMode={'single'}
                                value={this.state.tempDob}
                                onChange={(e) => {
                                    this.setState({ tempDob: e.value });
                                }}
                                placeholder="Select Date of Birth"
                                maxDate={new Date()}
                            />
                        </div>

                        <div className="text-center mt-6">
                            <Button
                                label="Save"
                                onClick={this.handleAgeCriteriaDobAccept}
                                className="confirmDialogAcceptBtn p-3"
                                style={{
                                    width: '150px',
                                    background: '#0066FF',
                                    border: 'none',
                                    borderRadius: '8px',
                                    color: 'white',
                                    fontSize: '16px',
                                    fontWeight: '600'
                                }}
                            />
                        </div>
                    </div>
                </Dialog>

                {
                    this.state.isLoading && <>
                        <LoadingComponent />
                    </>
                }
                < Toast ref={(el) => this.toast = el
                } position="bottom-right" />
            </>
        )
    }
}

// Update the mapStatesToProps function
const mapStatesToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoards'),
    branchData: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.data.filter((each => {
        if (each.level == 1) {
            return { ...each }
        }
    })) || [],
    permissionIds: state.currentUserPerms && state.currentUserPerms.permissionIds && state.currentUserPerms.permissionIds,
    userInfo: state.currentUserPerms && state.currentUserPerms.userInfo ? state.currentUserPerms.userInfo : {},
    // Add these props to match AppTopbar functionality
    academicYearOptions: state.academicYearOptions || [], // Add this from your app state
    selectedOption: state.selectedAcademicYear || localStorage.getItem('userAcademicYear'), // Add this
});


export default connect(mapStatesToProps, { getBoardsData, getBranchesLatest })(Authentication(withRouter(EnquiryAdd)));

